module.exports = __webpack_public_path__ + "static/img/goodImages3.81c3860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goodImages3.png
// module id = 2INs
// module chunks = 3